<template>
  <div class="order-copy pop_white-s pop_bege popup_wrap" style="display:block">
    <div class="popup_in">
      <div class="popup">
        <div class="corner-top"></div>
        <div class="exists_icon">
          <LOGO />
        </div>
        <div class="pop_frame">
          <h2 class="title25" style="margin-top:15px;">הוספנו לעגלה שלך <span style="" class="oftenProduct"  v-html="product.name"></span></h2>
          <div class="text">המוצר הזה חסר לפעמים במלאי. אם לא נמצא לך אותו.....</div>

          <div class="bt_green ease">
            <a href="#" @click.prevent="dontsent()">אל תספקו את המוצר</a>
          </div>
          <div class="bt_green ease">
            <a href="#" @click.prevent="replace()">החליפו עם מוצר דומה</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import close from "../../assets/img/close.svg";
import LOGO from "../../assets/img/carmella.svg";
import { mapActions } from "vuex";
import select2 from "../Select2";
export default {
  props: ["product"],
  data() {
    return {
      option: ""
    };
  },
  methods: {
    ...mapActions(["getProductById", "updateCart", "clarCart"]),
    dontsent() {
      this.product.product_often = "dontsend";
      this.updateCart([this.product]);
      this.closePop();
    },
    replace() {
      this.product.product_often = "replace";
      this.updateCart([this.product]);
      this.closePop();
    },
    addToCart() {},
    closePop() {
      this.$modal.hide("often");
    }
  },
  components: {
    LOGO,
    select2
  }
};
</script>

<style scoped>
.bt_green a {
  width: 320px;
}

</style>
